import { render, staticRenderFns } from "./classDetail2.vue?vue&type=template&id=a52c2d3e&scoped=true"
import script from "./classDetail2.vue?vue&type=script&lang=js"
export * from "./classDetail2.vue?vue&type=script&lang=js"
import style0 from "./classDetail2.vue?vue&type=style&index=0&id=a52c2d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c2d3e",
  null
  
)

export default component.exports